var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayHamburgerMenuSignOut = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.422 20.724H4.981a.827.827 0 0 1-.827-.827V5.014c0-.457.37-.827.827-.827h7.441a.826.826 0 1 0 0-1.654H4.981A2.484 2.484 0 0 0 2.5 5.013v14.884a2.484 2.484 0 0 0 2.48 2.481h7.442a.826.826 0 1 0 0-1.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.165 11.867-5.028-4.961a.827.827 0 1 0-1.16 1.177l3.592 3.546H9.942a.826.826 0 1 0 0 1.653h9.627l-3.593 3.546a.827.827 0 1 0 1.161 1.177l5.028-4.96a.828.828 0 0 0 0-1.178z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayHamburgerMenuSignOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-hamburger-menu-sign-out.b87895e7d71373408bcb30e0ab9559e3.svg";